import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { icons } from '../../../../../configs/Icons';
import { useTemplate } from '../../../../features/template/TemplateProvider';
import { ButtonPest } from '../../../../utils/Button';
import { CamelCaseToHyphen } from '../../../../utils/TextFormatter';
import { GetDynamicValue, mkRelativeUrl } from '../../../../utils/URL';
import cn from '../../../../utils/cn';

function TabButton({ title, name, active, onClick }) {
    return (
        <button
            type="button"
            onClick={() => onClick(CamelCaseToHyphen(name?.toLowerCase()))}
            className={cn(
                `group h-full w-full md:w-auto md:min-w-20 flex justify-center items-center gap-2.5 bg-transparent text-secondary hover:bg-secondary hover:text-white font-medium text-base focus:outline-none outline-none transition-colors cursor-pointer rounded-md px-3 py-2`,
                {
                    'active bg-secondary text-white': active
                }
            )}
        >
            <span className="inline-block capitalize whitespace-nowrap">{title || name}</span>
        </button>
    );
}

function AgencyTabView({ data }) {
    const { openModal } = useTemplate();
    const navigate = useNavigate();
    const { id } = data;
    const [activeTab, setActiveTab] = useState(GetDynamicValue('tab') || 'customers');
    const handleSetTab = (tab) => {
        setActiveTab(tab);
        navigate(mkRelativeUrl(`/agency/${id}/${tab}`));
    };
    return (
        <div className="flex justify-start items-center gap-2 title text-xl font-medium text-primary mb-4 ml-[1px]">
            <div className="flex flex-wrap flex-row gap-2 flex-1 items-center justify-between overflow-hidden">
                <span
                    className={cn(
                        'h-13 p-[5px] flex sm:inline-flex flex-nowrap justify-start items-center gap-[5px] bg-secondary-100 rounded-10 overflow-auto md:overflow-hidden custom-scrollbar scroll-h-sm',
                        {
                            'placeholder-mode': data?.demo
                        }
                    )}
                >
                    <TabButton
                        name="customers"
                        onClick={handleSetTab}
                        active={activeTab === 'customers'}
                    />
                    <TabButton
                        name="subscriptions"
                        onClick={handleSetTab}
                        active={activeTab === 'subscriptions'}
                    />
                    <TabButton
                        name="services"
                        title="Services"
                        onClick={handleSetTab}
                        active={activeTab === 'services'}
                        total={data?.payments?.length}
                    />
                    <TabButton
                        name="invoices"
                        onClick={handleSetTab}
                        active={activeTab === 'invoices'}
                    />
                    <TabButton
                        name="payments"
                        onClick={handleSetTab}
                        active={activeTab === 'payments'}
                    />

                    <TabButton
                        title="Support Ticket's"
                        name="support-ticket"
                        onClick={handleSetTab}
                        active={activeTab === 'support-ticket'}
                    />
                </span>

                <div className="flex flex-col sm:flex-row gap-3">
                    <ButtonPest
                        onClick={() =>
                            openModal('create-agency-customer-modal', {
                                id: data?.id,
                                organization: data?.organization
                            })
                        }
                        className="w-50 h-10 md:h-13 text-base flex justify-center items-center gap-2"
                        disabled={data?.demo || data?.status === 'inactive'}
                    >
                        <img src={icons.plusW} alt="Plus" className="pb-0.5" />
                        <span>Create Customer</span>
                    </ButtonPest>
                </div>
            </div>
        </div>
    );
}

export default AgencyTabView;
